<template>
  <claim-blank-form
    submit-label="Добавить заявку"
    :claim="claim"
    :errors="errors"
    form-type="add"
    @submit="processClaimForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addClaim } from '@/services/claim.service'
import claimBlankForm from '@/components/forms/claim/ClaimBlankForm'

export default {
  name: 'claim-add-form',
  components: { claimBlankForm },
  data () {
    return {
      claim: {
        id: null,
        text: '',
        datetime: '',
        client: ''
      },

      errors: {
        claim: {
          id: [],
          text: [],
          datetime: [],
          client: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processClaimForm () {
      this.addClaim().then((success) => {
        if (success) {
          this.showMsg('Заявка была успешно добавлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addClaim () {
      return addClaim(this.claim).then((response) => {
        this.claim = response.data
        this.fillErrors(this.errors.claim, {})
        return true
      }).catch(err => {
        console.log(err.response)
        this.fillErrors(this.errors.claim, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClaimAddForm.vue?2e349618